<script setup lang="ts">
import { useDisplay } from 'vuetify';

import ActionButton from '@/components/buttons/ActionButton.vue';

import AfModal from '@/components/overlays/AfModal.vue';
import { useModalStore } from './modalStore';
import { computed, inject } from 'vue';
import type { Translate } from '@/plugins/i18n/types';
import { useUserQuery } from '@/api/queries/user/useUserQuery';
import { useConsentMutation } from '@/api/mutations/user/useConsentMutation';
import { ref } from 'vue';

const modalStore = useModalStore();
const { user } = useUserQuery();
const { updateConsent } = useConsentMutation(ref({ tou: true }));

const { smAndDown } = useDisplay();
const t = inject('t') as Translate;

function patchConsent() {
  updateConsent();
}

function handleCloseModal() {
  patchConsent();
  modalStore.toggle('cguUpdate');
}

const cguUrl = computed(() =>
  user.value?.locale_id === 1
    ? 'https://www.assessfirst.com/fr/conditions-generales-utilisation'
    : 'https://www.assessfirst.com/en/terms-of-use',
);

const privacyUrl = computed(() =>
  user.value?.locale_id === 1
    ? 'https://www.assessfirst.com/fr/politique-relative-aux-donnees-a-caractere-personnel'
    : 'https://www.assessfirst.com/en/privacy-policy',
);
const legalTextWithLinks = computed(() => {
  return t('general.legal.update.body')
    .replace(
      /<a>/,
      `<a href="${cguUrl.value}" target="_blank" rel="noopener noreferrer"
        class="underline hover:no-underline text-af-blue-600 font-weight-medium">`,
    )
    .replace(
      /<a>/,
      `<a href="${privacyUrl.value}" target="_blank" rel="noopener noreferrer"
        class="underline hover:no-underline text-af-blue-600 font-weight-medium">`,
    );
});
</script>

<template>
  <AfModal
    max-width="550px"
    v-model="modalStore.cguUpdate.visible"
    transition="scale-transition"
    :header="false"
    :fullscreen="smAndDown"
    :footer="false"
    @close="patchConsent"
  >
    <template #content>
      <div class="flex flex-col items-center p-3 gap-5 md:gap-6">
        <h2 class="text-h2 my-1 leading-normal">{{ $t('general.legal.update.title') }}</h2>
        <p class="text-body-2 font-weight-light" v-html="legalTextWithLinks"></p>
        <ActionButton cancel @click="handleCloseModal" class="mr-5">
          {{ $t('general.close') }}
        </ActionButton>
      </div>
    </template>
  </AfModal>
</template>
